module.exports={author:"Veronica Martin",date:"08/19/2019",publishDate:"08/19/2019",highlighted:!1,tags:"",title:"Epilogue in Summer"};